import { useRequest } from 'ahooks'
import classnames from 'classnames'
import React, { FC } from 'react'

import HInput from '../../HYBVant/HInput'

import { publicEvents } from '../../HYBVant/utils'

import { systemTextCode } from './service'
import './index.less'

interface IProps {
  /**
   * 按钮文案
   */
  btn_text?: string
  /**
   * 最大长度
   */
  maxLength?: number
  /**
   * 是否换行
   */
  isLineFeed?: boolean
  /**
   * 是否已读
   */
  readed?: boolean
  [key: string]: any
}
// 自动获取工号
function AutoJobNumber(props: IProps) {
  const {
    value,
    onChange,
    disabled = false,
    maxLength = 32,
    code = 'EMPLOYEE_NO',
    isLineFeed = false,
    btn_text = '自动生成',
    readed = false
  } = props || {}

  const dealChange = (text_v: any) => {
    onChange(text_v)
    publicEvents.onChange.call(props, text_v)
  }

  // 自动获取工号
  const autoJobNumberClick = () => {
    if (!disabled) {
      runSystemTextCodeList({
        type: code,
        count: 1
      })
    }
  }
  // // 系统文本生成规则类型
  // const btnTextRander = () => {
  //   let textStr: any = ''
  //   switch (btn_text) {
  //     case '按规则生成编码':
  //       textStr = 'CONTRACT_NO'
  //       break
  //     default:
  //       textStr = 'EMPLOYEE_NO'
  //   }
  //   return textStr
  // }
  // 生成编码
  const { run: runSystemTextCodeList } = useRequest(systemTextCode, {
    manual: true,
    onSuccess: (result: any) => {
      const { data, code } = result
      if (code === 2000) {
        const code_id = Array.isArray(data) ? data?.[0] : null
        dealChange(code_id)
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })
  return (
    <div
      className={classnames('auto-job-number-box', {
        'line-feed': isLineFeed,
        'auto-job-number-box-readed': readed
      })}
    >
      <HInput maxLength={maxLength} disabled={disabled} value={value} onConfirm={dealChange} />
      {!readed && (
        <div
          className={classnames('auto-job-btn', { 'not-disabled': disabled })}
          onClick={() => autoJobNumberClick()}
        >
          {btn_text}
        </div>
      )}
    </div>
  )
}

export default AutoJobNumber
